export enum LocationStatuses {
  Active = 1,
  ComingSoon,
  Disabled,
}
